import * as THREE from 'three';
import { Base3DPart } from "./base-part";

export class Machine3DPart extends Base3DPart {
    override load(scene: THREE.Scene): void {
        const objPath = `${this.basePath}/macchina.gltf`;

        this.gltfLoader.load(objPath, (gltf) => {
            scene.add(gltf.scene);
        });
    }
}